import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../service/caller';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [UserData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const navigate = useNavigate();
  // Fonction combinée pour charger les données
  const loadData = async () => {
    setLoading(true);
    try {
      // 1. Récupérer les données utilisateur
      const userResponse = await api.get('api/usersprofile');
      const UserData = userResponse.data;
      setUserData(UserData);

      // 2. Récupérer les permissions (seulement si non incluses dans UserData)
      if (!UserData.permissions || UserData.permissions.length === 0) {
        const permResponse = await api.get('api/getallpermissions');
        setPermissions(permResponse.data);
      } else {
        setPermissions(UserData.permissions);
      }

    } catch (error) {
      console.error("Erreur lors du chargement des données:", error);
      if (error.response?.status === 401) {
        // Gérer l'expiration du token
        toast.error("Session expirée, veuillez vous reconnecter");
        navigate('/clientlogin');
        // Vous pourriez rediriger vers la page de login ici
      }
    } finally {
      setLoading(false);
      setInitialLoadDone(true);
    }
  };

  // Effet pour le chargement initial
  useEffect(() => {
    if (!initialLoadDone) {
      loadData();
    }
  }, [initialLoadDone]);

  // Fonction de vérification des permissions
  const hasPermission = (permissionName) => {
    if (loading || !UserData || !UserData.permissions) return false;
    
    return UserData.permissions.some(perm => 
      typeof perm === 'string' 
        ? perm === permissionName 
        : perm.name === permissionName || perm._id === permissionName
    );
  };

  // Fonction pour rafraîchir les données
  const refreshData = () => {
    setInitialLoadDone(false);
  };

  // Valeurs exposées
  const value = {
    permissions,
    UserData,
    loading,
    hasPermission,
    refreshData,
    updateUserData: setUserData // Permet de mettre à jour les données manuellement
  };

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
};

export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (context === undefined) {
    throw new Error('usePermissions must be used within a PermissionProvider');
  }
  return context;
};